<div class="container p-4">
    <div class="row mt-2">
        <h6>Get User List</h6>
        <ul>
            <li class="mt-3">
                <div class="font-weight-bold">Users Assigned to One or More of the Selected Projects <small class="text-muted">(no project selected will return all)</small></div>
                <div>
                    <div *ngFor="let project of projects">
                        <input class="form-check-input project-checkbox" type="checkbox" value="{{project.id}}" id="{{project.name}}">
                        <label class="form-check-label" for="{{project.name}}">
                        {{project.name}}
                        </label>
                    </div>
                </div>
            </li>
            <li class="mt-3">
                <div class="mt-1 mb-2font-weight-bold">Users that are a Member of One or More of the Selected Roles <small class="text-muted">(no roles selected will return all)</small></div>
                <div>
                    <div *ngFor="let role of roles">
                        <input class="form-check-input role-checkbox" type="checkbox" value="{{role}}" id="{{role}}">
                        <label class="form-check-label" for="{{role}}">
                        {{role}}
                        </label>
                    </div>
                </div>                            
            </li>
        </ul>
    </div>
    <div class="mt-4">

    </div>
    <div class="mt-2 row">
        <div class="col-2">
            <button type="button" class="btn btn-secondary mt-2 me-2" (click)="close()">Cancel</button>
        </div>
        <div class="col-10 text-end" *ngIf="!running">          
            <button type="button" class="btn btn-primary mt-2 me-2" (click)="addTo('to')">Add To</button>
            <button type="button" class="btn btn-primary mt-2 me-2" (click)="addTo('cc')">Add CC</button>
            <button type="button" class="btn btn-primary mt-2 me-2" (click)="addTo('bcc')">Add BCC</button>
            <button type="button" class="btn btn-primary mt-2 me-2" (click)="addTo('clipboard')">Copy to Clipboard</button>
        </div>
        <div class="col-10 text-end" *ngIf="running">          
            <button type="button" class="btn btn-primary disabled mt-2 me-2">Getting users...</button>
        </div>
    </div>
</div>